// extracted by mini-css-extract-plugin
module.exports = {"navbar":"c-asCIC","arrow":"UOsyvA","focus":"c61RvjH","arrowLeft":"R89jpx","arrowRight":"TtpJ0U"};